import React from 'react';

import { TProfileUserCard } from '@/API/models';
import ProfilePicture from '@/components/ProfilePicture';

const ProfileUserCard = ({
  card,
  handleToggleCards,
  profileCardsExpanded,
  showExpandCardsButton,
  isUserRole,
}: {
  card: TProfileUserCard;
  handleToggleCards: () => void;
  profileCardsExpanded: boolean;
  showExpandCardsButton: boolean;
  isUserRole: boolean;
}) => {
  const { icon, role, firstName, lastName, member_since } = card;

  return (
    <div
      className={`grid ${isUserRole ? 'header-card mb-10' : 'header-card-full-width'} gap-4 media-915:gap-10 bg-translucent p-10 w-full media-915:rounded-xl relative box-border shadow-profileCard rounded-xl media-915:mb-0`}
    >
      <div className='self-center basis-auto flex-1'>
        <ProfilePicture url={icon} tier={0} />
      </div>
      <div className='overflow-hidden'>
        <p className='uppercase text-11px media-915:text-14px font-light text-white pb-5 font-sans whitespace-nowrap'>
          {role}
        </p>
        <div className='w-full overflow-hidden overflow-ellipsis pb-4 '>
          <p className='uppercase text-18px media-915:text-20px font-normal text-white truncate font-sans whitespace-pre-wrap '>
            {firstName} {lastName}
          </p>
        </div>
        {member_since && (
          <p className='text-11px font-normal text-white font-serif'>
            Member since: {member_since}
          </p>
        )}
      </div>

      {showExpandCardsButton && (
        <button
          style={{
            position: 'absolute',
            bottom: '-1.4rem',
            right: '1.5rem',
            background: 'white',
            width: '30px',
            height: '22px',
          }}
          className='flex items-center justify-center border-none rounded-2xl'
          aria-label={profileCardsExpanded ? 'Hide' : 'Show'}
          onClick={handleToggleCards}
        >
          <img
            src='/icons/arrow-up.svg'
            alt=''
            className={`${profileCardsExpanded ? 'default' : 'rotated'}`}
          />
        </button>
      )}
    </div>
  );
};
export default ProfileUserCard;
